import React from 'react';

const BoldError = ({ message }) => {
    return message ? <div className="alert alert-danger" role="alert">
        {message}
    </div> : null;
}

export default BoldError;